import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { FocuspayReportingService } from 'src/app/core/services/focuspay-reporting.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { DatacapBatchRecord } from 'src/app/shared/models/DTO/FocusPayDatacap/DatacapReportSummary.dto';
import { ChartLegendPosition } from 'src/app/shared/models/enums/ChartLegendPosition.enum';

@Component({
	selector: 'app-credit-dashboard-chart',
	templateUrl: './credit-dashboard-chart.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class CreditDashboardChartComponent implements OnInit, OnDestroy {
	batchRecordSubscription: Subscription;

	chart = {
		options: this.app.references.chartConfig(ChartLegendPosition.NONE, false, false),
		data: undefined,
	};

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		private focuslink: FocuslinkService,
		public focusPayReportingService: FocuspayReportingService
	) {}
	ngOnDestroy(): void {
		this.batchRecordSubscription.unsubscribe();
	}

	ngOnInit(): void {
		this.batchRecordSubscription = this.focusPayReportingService.batchRecords.subscribe((batchRecords) => {
			this.buildChart(batchRecords);
		});
	}

	buildChart(batchRecords: DatacapBatchRecord[]) {
		console.log('build chart');

		const data = {
			labels: batchRecords.map((batchRecord) => this.app.moment(batchRecord.businessDate, 'MMDDYYYY').format('MM/DD/YYYY')).reverse(),
			datasets: [
				{
					label: 'labels',
					data: batchRecords?.map((i) => i.amount).reverse(),
					fill: true,
					borderColor: this.app.references.colorPallete.primary,
					backgroundColor: this.app.references.transparentize(this.app.references.colorPallete.primary, 0.75),
					yAxisID: 'y',
					tension: 0.4,
				},
			],
		};
		console.log(data);
		this.chart.data = data;
	}
}
